module.exports = __webpack_public_path__ + "static/media/leg.8755e8cd.svg";